import { MoneySchema } from "@redotech/money";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getMercuryAnalyticsForCheckoutExperience = {
  name: "getMercuryAnalyticsForCheckoutExperience" as const,
  input: z.object({ checkoutExperienceId: zExt.objectId() }),
  output: z.object({
    checkoutShippingPriceBucketsByRateTableId: z.record(
      z.string(),
      z.object({
        shippingPriceBuckets: z.array(
          z.object({
            shippingPriceBucketMin: MoneySchema,
            checkoutCount: z.number(),
          }),
        ),
      }),
    ),
    shippingMarginsByOrderValueByRateTableId: z.record(
      z.string(), // rate table id
      z.object({
        shippingMarginsByOrderValue: z.array(
          z.object({ orderValue: MoneySchema, shippingMargin: MoneySchema }),
        ),
      }),
    ),
    rateTableNames: z.record(z.string(), z.string()), // rate table id -> rate table name
  }),
};
